import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Button,
  Image,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Modal,
  Overlay,
} from "react-bootstrap";
import { getStyles } from "./StoreView.style";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Section from "../../Components/Section/Section";
import { FaArrowRight, FaRegClock, FaSearch, FaStar } from "react-icons/fa";
import { LuChevronRight, LuStore } from "react-icons/lu";
import storeImage from "../../assets/images/default-shop.png";
import { Rating } from "react-simple-star-rating";
import SubcategoryWiseProduct from "../../Components/SubcategoryWiseProduct/SubcategoryWiseProduct";
import MainCategory from "../../Components/MainCategories/MainCategories";
import StoreSubcategoryWiseProduct from "../../Components/StoreSubcategoryWiseProduct/StoreSubcategoryWiseProduct";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/Store";
import FormControl from "react-bootstrap/esm/FormControl";
import { SET_STORE_VIEW_SEARCH } from "../../Redux/Search";
import { useTranslation } from "react-i18next";
import { base_url } from "../../Api/ApiConst";
import {
  SET_SELECTED_PRODUCT,
  SET_SELECTED_SUBCATEGORY_ID,
} from "../../Redux/productId";
import {
  Search_Store_Product,
  Search_Store_Product_Suggestions,
  Selected_Store_Rating,
  User_Last_Viewed,
} from "../../Api";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { parseInt } from "lodash";
import defaultAvtaar from "../../assets/images/User.png";
import { toast } from "react-toastify";
import NoDataFound from "../../Components/NoDataFound/NoDataFound";
import Popover from "react-bootstrap/esm/Popover";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import debounce from "lodash.debounce";
import { getImageUrl } from "../../Utils/imageUtils";
import StoreCarousel from "../../Components/StoreCarousel/StoreCarousel";
import StoreBannerFallback, {
  getSupplyMethodLabelKey,
} from "../../Components/StoreCarousel/StoreBannerFallback";

const StoreView: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = React.useState<any>(false);
  const [reviews, setReviews] = React.useState<any>([]);
  const [suggestions, setSuggestions] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<any>(1);
  const [isSearch, setIsSearch] = React.useState<any>("true");
  const [userToken, setUserToken] = React.useState<any>("");

  const styles = getStyles(isMobile);
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;

  const searchTerm: any = useSelector(
    (state: RootState) => state.Search.StoreViewSearch
  );

  const SelectedSubcategory: any = useSelector(
    (state: RootState) => state.productId.selectedSubcategory_id
  );

  const [searchText, setSearchText] = useState<any>("");
  const mainName = useSelector(
    (state: RootState) => state.mainCategory.selectedMainCategory
  );
  const languageId: any = useSelector((state: RootState) => state.lan);

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(SET_SELECTED_SUBCATEGORY_ID(""));
  }, []);

  useEffect(() => {
    debouncedHandleSearch(searchText);
  }, [searchText]);

  useEffect(() => {
    setSearchText(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    if (state === null || state === undefined) {
      navigate("/", { replace: true });
    }
    return;
  }, [state, navigate]);

  const breadcrumbs = [
    <Link to="/" key="home" className="text-reset text-decoration-none">
      {t("footer.home")}
    </Link>,
    mainName?.language_data?.length === 0
      ? mainName?.name
      : languageId === "ne"
        ? mainName?.language_data[0]?.name
        : mainName?.name,
  ];

  const handleSearch = (name: any) => {
    dispatch(SET_STORE_VIEW_SEARCH(name ? name : searchText));
  };

  const StoreRating = async () => {
    try {
      const response = await Selected_Store_Rating(storeId);
      if (response && response.status === 200) {
        // console.log(response.data, "buyyyy---------->");
        if (response.data.status === true) {
          setReviews(response.data.store_rating_list);
        } else {
          setReviews([]);
        }
      } else {
        console.log("Error fetching Past orders");
        toast.error(response?.data?.error);
      }
    } catch (error) {
      console.log("Error fetching Past orders", error);
    }
  };

  const debouncedHandleSearch = debounce(async (searchText: any) => {
    if (searchText) {
      try {
        const response = await Search_Store_Product_Suggestions(
          searchText,
          storeId,
          isSearch
        );
        if (response && response.status === 200) {
          const formattedStores = response.data.product_list.map(
            (product: any) => ({
              id: product?.id,
              img: product?.product_image,
              name: product?.product_name,
            })
          );
          setSuggestions(formattedStores);
          dispatch(
            SET_SELECTED_SUBCATEGORY_ID(
              response?.data?.search_product_list[0]?.product_subcategory
            )
          );
        } else {
          console.log("Error fetching Store Product Details");
        }
      } catch (error) {
        console.log("Error fetching Store Product Details", error);
      }
    }
  }, 500);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch("");
    }
  };

  const fetchReviews = () => {
    setShowModal(true);
  };

  if (!state) {
    return null;
  }

  const {
    store_name,
    store_type,
    distance_in_km,
    language_data,
    store_logo,
    store_rating,
    storeId,
  } = state;

  const storeDisplayName =
    language_data === undefined
      ? store_name
      : languageId === "ne"
        ? language_data
        : store_name;

  // store_type is the supply method (ONLY_DELIVERY, ...), labelled as on store registration
  const supplyLabelKey = getSupplyMethodLabelKey(store_type);
  const supplyLabel = supplyLabelKey ? t(supplyLabelKey) : "";

  // Shown on the right of the products section's title row
  const productSearch = (
    <div style={styles.searchBox}>
    <div style={{ flex: 1 }}>
      <ReactSearchAutocomplete
        className="compact-search-input"
        items={suggestions}
        onSearch={(input: string) => setSearchText(input)}
        onSelect={(item: any) => handleSearch(item?.name)}
        formatResult={(item: any) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "6px 0",
            }}
          >
            {item?.img && (
              <div
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "4px",
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  src={getImageUrl(item?.img)}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  alt={item?.name}
                />
              </div>
            )}
            <span
              style={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#333",
              }}
            >
              {item?.name}
            </span>
          </div>
        )}
        autoFocus={true}
        styling={{
          borderRadius: "15px",
          border: "none",
          boxShadow: "none",
          fontSize: "14px",
          fontFamily: "var(--primary-font-medium)",
          height: "35px",
        }}
        placeholder="Search products..."
      />
    </div>

    <Button
      variant="primary"
      className="compact-search-btn"
      onClick={() => handleSearch("")}
      style={{
        background:
          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        border: "none",
        borderRadius: "15px",
        padding: "8px 12px",
        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
        transition: "all 0.3s ease",
        fontWeight: 600,
        fontSize: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "35px",
        height: "35px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow =
          "0 6px 20px rgba(102, 126, 234, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow =
          "0 4px 15px rgba(102, 126, 234, 0.3)";
      }}
    >
      <FaSearch style={{ fontSize: "12px" }} />
    </Button>
    </div>
  );

  return (
    <div className="store">
      <Section className="storeView" style={styles.bg}>
        <Container>
          {/* Breadcrumbs: Home > category > store */}
          <nav aria-label="breadcrumb" className="breadcrumbs mb-2">
            <ol
              className="list-unstyled d-flex flex-wrap align-items-center gap-1 mb-0"
              style={styles.breadcrumb}
            >
              {[...breadcrumbs.filter(Boolean), storeDisplayName].map(
                (crumb, index, crumbs) => {
                  const isLast = index === crumbs.length - 1;
                  return (
                    <li
                      key={index}
                      className="d-flex align-items-center gap-1"
                      aria-current={isLast ? "page" : undefined}
                      style={isLast ? styles.breadcrumbCurrent : undefined}
                    >
                      {crumb}
                      {!isLast && <LuChevronRight size={12} />}
                    </li>
                  );
                }
              )}
            </ol>
          </nav>

          {/* Store header card + banners */}
          <div className="d-flex flex-column gap-4 pb-3">
            {/* Store Profile Bar (Figma: STORE HEADER CARD) */}
            <div className="bg-white rounded-4 shadow-sm pb-3 d-flex flex-wrap justify-content-between align-items-end gap-3">
              <div className="d-flex align-items-end gap-3 ps-3" style={{ minWidth: 0 }}>
                <div
                  className={`d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden rounded-4 border border-4 border-white ${
                    store_logo ? "bg-white" : ""
                  }`}
                  style={store_logo ? styles.headerLogo : styles.headerLogoBrand}
                >
                  {store_logo ? (
                    <Image
                      src={getImageUrl(store_logo)}
                      alt={storeDisplayName}
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <LuStore size={26} color="#FFFFFF" />
                  )}
                </div>
                <div className="pt-2" style={{ minWidth: 0 }}>
                  <h1 className="fs-2 fw-semibold text-dark lh-sm mb-0 text-truncate">
                    {storeDisplayName}
                  </h1>
                  {supplyLabel && (
                    <div className="d-flex flex-wrap align-items-center gap-2 pt-2">
                      <span className="badge rounded-2 fw-semibold bg-primary-subtle text-body-secondary">
                        {supplyLabel}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {store_rating !== undefined && (
                <div className="pt-2">
                  <button
                    type="button"
                    className="btn btn-sm d-inline-flex align-items-center gap-2 rounded-1 border-0 bg-warning-subtle"
                    onClick={fetchReviews}
                  >
                    <FaStar className="text-warning" size={16} />
                    <span className="fw-semibold text-dark">
                      {Math.round(store_rating * 10) / 10}
                    </span>
                    <span className="small text-body-secondary">(Reviews)</span>
                  </button>
                </div>
              )}
            </div>

            <StoreCarousel
              storeId={storeId}
              fallbackContent={
                <StoreBannerFallback
                  storeName={storeDisplayName}
                  storeType={store_type}
                />
              }
            />
          </div>
        </Container>
      </Section>

      <StoreSubcategoryWiseProduct headerRight={productSearch} />

      <Modal
        centered
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        className="ratingModal storeRatingModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("userProfile.storeReviews")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reviews && reviews.length === 0 ? (
            <NoDataFound title={t("commonHeader.noReviews")} />
          ) : (
            reviews.length > 0 &&
            reviews &&
            reviews.map((review: any) => (
              <div key={review.id} className="mb-3 store-rating-wrap">
                <div className="d-flex align-items-start">
                  <Image
                    src={review.user_image ? review.user_image : defaultAvtaar}
                    roundedCircle
                    width={50}
                    height={50}
                    style={{ marginRight: 10 }}
                  />
                  <div>
                    <h5 className="mb-0">
                      {review.customer_name
                        ? review.customer_name
                        : "Anonymous User"}
                    </h5>
                    <Rating
                      initialValue={review.rate}
                      allowHover={false}
                      readonly={true}
                      size={22}
                      style={{ marginBottom: "0.5rem" }}
                    />
                    <p className="mb-0">{review.client_comment}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("commonHeader.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StoreView;
